import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppStateService } from "src/app/shared/app-state.service";

@Component({
  selector: "app-vape-pen-cartridges-shop-online-in-bronx",
  templateUrl: "./vape-pen-cartridges-shop-online-in-bronx.component.html",
  styleUrls: ["./vape-pen-cartridges-shop-online-in-bronx.component.css"],
})
export class VapePenCartridgesShopOnlineInBronxComponent {
  productListing: any = [];
  loader2: boolean = false;
  payload: any = {
    Brand: [],
    CBDMax: 0,
    CBDMin: 0,
    NetWeight: [],
    Species: [],
    THCMax: 0,
    THCMin: 0,
    categorySlug: "vaporizers",
    pageNumber: 1,
    productUnder: 0,
    resPerPage: 15,
    storeId: "349669",
    tags: [],
  };
  constructor(
    private router: Router,
    private appStateSvc: AppStateService,
  ) {
    this.payload;
  }

  ngOnInit(): void {}

  routeMeTo(url) {
    this.router.navigateByUrl(url).then(() => {
      window.scrollTo(0, 0);
    });
  }
  getColor(type) {
    let style: any;
    let siteDada = JSON.parse(localStorage.getItem("siteData"));
    if (siteDada?.viewMoreButtonColor) {
      style = { color: siteDada?.viewMoreButtonColor };
    } else {
      style = { color: "#000" };
    }

    return style;
  }

  getBackGroundColorAccToSpecies(name) {
    return "#f8f8f8";
  }

  redirectToDetailPage(slug: string) {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    this.appStateSvc.setState({
      dashboardScrollPosition: scrollPosition,
    });
    this.router.navigateByUrl(`/shop/product/${slug}`);
  }

  defaultUrl = "assets/images/defaultimg.jpeg";
  getImageSize3(array) {
    if (array.length) {
      return array[0]["Uri"];
    } else {
      return this.defaultUrl;
    }
  }
  checkThc(min, max) {
    if (min < max) {
      return true;
    } else {
      return false;
    }
  }

  getBrandName(data) {
    let brandObj = data.productDetails.brand;
    let name =
      brandObj["brandName"] != "" ? brandObj["brandName"] : "BRAND NAME";
    return name;
  }

  getBackGroundColor(tag) {
    if (tag) {
      return tag.tagColor;
    } else {
      return "#FFFFFF";
    }
  }

  getFullName(item: any) {
    if (item != undefined && item != null) {
      return item?.split("")[0];
    }
  }

  checkZero(value: any) {
    if (value == 0 || value == null || value == undefined) {
      return false;
    } else {
      return true;
    }
  }
  thcType(type) {
    if (type == 0 || type == null || type == undefined) {
      return "%";
    } else {
      return type;
    }
  }
}
